var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass:
        "m-nav__item m-dropdown m-dropdown--large m-dropdown--arrow m-dropdown--align-center m-dropdown--mobile-full-width m-dropdown--skin-light\tm-list-search m-list-search--skin-light",
      class: _vm.searchStr.length > 2 ? "m-dropdown--open" : "",
      attrs: {
        "data-dropdown-toggle": "click",
        "data-dropdown-persistent": "true",
        id: "m_quicksearch",
        "data-search-type": "dropdown"
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "m-dropdown__wrapper" }, [
        _c("span", {
          staticClass: "m-dropdown__arrow m-dropdown__arrow--center"
        }),
        _vm._v(" "),
        _c("div", { staticClass: "m-dropdown__inner " }, [
          _c("div", { staticClass: "m-dropdown__header" }, [
            _c("form", { staticClass: "m-list-search__form" }, [
              _c("div", { staticClass: "m-list-search__form-wrapper" }, [
                _c(
                  "span",
                  { staticClass: "m-list-search__form-input-wrapper" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchStr,
                          expression: "searchStr"
                        }
                      ],
                      staticClass: "m-list-search__form-input",
                      attrs: {
                        id: "profo-search",
                        autocomplete: "off",
                        type: "text",
                        placeholder: "Suche..."
                      },
                      domProps: { value: _vm.searchStr },
                      on: {
                        keyup: function($event) {
                          return _vm.search()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchStr = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm._m(1)
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "m-dropdown__scrollable m-scrollable",
                attrs: {
                  "data-scrollable": "true",
                  "data-max-height": "300",
                  "data-mobile-max-height": "200"
                }
              },
              [
                _c("div", { staticClass: "m-dropdown__content" }, [
                  _c(
                    "div",
                    { staticClass: "quick-search-result" },
                    _vm._l(_vm.searchArr, function(client) {
                      return _c("div", { staticClass: "mb-10" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center flex-grow-1 mb-2"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex flex-column ml-3 mt-2 mb-2"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "font-weight-bold text-dark text-hover-primary mb-3",
                                    attrs: { href: "/kunde-" + client.id }
                                  },
                                  [
                                    _c("b", { staticClass: "text-primary" }, [
                                      _vm._v(_vm._s(client.id))
                                    ]),
                                    _vm._v(" - "),
                                    client.company != ""
                                      ? _c("b", [
                                          _vm._v(_vm._s(client.company))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-info" }, [
                                      _vm._v(
                                        _vm._s(client.prename) +
                                          " " +
                                          _vm._s(client.name)
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(client.projects.slice(0, 5), function(
                                  project
                                ) {
                                  return _c(
                                    "a",
                                    {
                                      key: "search-pro-" + project.id,
                                      staticClass:
                                        "font-size-sm font-weight-bold text-muted mb-2",
                                      attrs: { href: "projekt-" + project.id }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(project.client_project_count) +
                                          " - " +
                                          _vm._s(project.name) +
                                          " (" +
                                          _vm._s(project.created_at) +
                                          ")"
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "m-nav__link m-dropdown__toggle", attrs: { href: "#" } },
      [
        _c("span", { staticClass: "m-nav__link-icon" }, [
          _c("i", { staticClass: "flaticon-search-1" })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "m-list-search__form-icon-close",
        attrs: { id: "m_quicksearch_close" }
      },
      [_c("i", { staticClass: "la la-remove" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }